import { render, staticRenderFns } from "./TreatmentLoop.vue?vue&type=template&id=5d1db04c&"
import script from "./TreatmentLoop.vue?vue&type=script&lang=js&"
export * from "./TreatmentLoop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports